<style>
    td,
    th {
        @apply border border-blue-700;
    }
</style>

<script>
    import { comoMoneda } from '../utils';

    export let ventas_producto = [];
    export let num_venta = 0;
    // export let fecha;
    export let total_productos = 0;
    export let total_precio = 0;
    export let cliente = '';
    export let fecha = null;
    $: formattedDate =
        fecha &&
        `${fecha.slice(8, 10)}-${fecha.slice(5, 7)}-${fecha.slice(0, 4)}`;

    $: cantidadCalculada = ventas_producto.reduce(
        (cantidadTotal, { cantidad }) => cantidadTotal + cantidad,
        0
    );
    $: totalCalculado = ventas_producto.reduce(
        (total, { precio, cantidad, subtotal }) =>
            total + subtotal || precio * cantidad,
        0
    );
</script>

<div class="">
    <div class="flex pb-2 mb-6 border-b-2 border-red-700">
        <img class="object-contain h-20 mt-auto" src="/swipe_logo.jpg" alt="" />
        <div class="flex-1 mx-12 text-center">
            <div class="-my-4 text-6xl text-blue-800 font-italianno">
                Carmen Jaime
            </div>
            <div class="font-bold text-red-700">Distribuidora Oficial</div>
        </div>
        <div class="flex flex-col">
            <div class="mb-auto ml-auto">{num_venta}</div>
            <div class="flex ml-auto">
                <img class="object-contain h-6" src="/whatsapp.png" alt="" />
                <div class="ml-2 font-bold">3334408597</div>
            </div>
        </div>
    </div>
    <div class="flex mb-6">
        <div class="mr-2 font-bold">Nombre del cliente:</div>
        {cliente}
        <div class="ml-auto">{formattedDate || ''}</div>
    </div>

    <table class="w-full border">
        <thead>
            <tr>
                <th>Cantidad</th>
                <th>Producto</th>
                <th>Precio Unitario</th>
                <th>Subtotal</th>
            </tr>
        </thead>
        <tbody>
            {#each ventas_producto as { nombre, slug, cantidad, precio, subtotal }}
                <tr>
                    <td class="text-right">{cantidad}</td>
                    <td>{nombre}</td>
                    <td class="text-right">{comoMoneda(precio)}</td>
                    <td class="text-right">
                        {comoMoneda(subtotal || precio * cantidad)}
                    </td>
                </tr>
            {/each}
            <slot name="agregarProducto" />
        </tbody>
        <tfoot>
            <tr class="text-lg font-bold">
                <td class="text-right">
                    {total_productos || cantidadCalculada}
                </td>
                <td colspan="2">Total</td>
                <td class="text-right">
                    {comoMoneda(total_precio || totalCalculado)}
                </td>
            </tr>
        </tfoot>
    </table>
    <div class="mt-3 text-4xl font-bold text-blue-800 font-italianno">
        Muchas gracias por tu compra y por recomendarnos!
    </div>
</div>
